import { useSessionStore } from 'app_alegra_commons/session'
import { useAppStore } from 'app_alegra_commons/app'
import { getDictonaryFromObject } from 'app_alegra_commons/utils'
import { computed } from 'vue'

export default function () {
  const SESSION = useSessionStore()
  const APP = useAppStore()

  const loadUserInfo = async (dictionary: object): Promise<void> => {
    await SESSION.getUser(dictionary)
  }

  const reloadUserInfo = async (): Promise<void> => {
    await SESSION.reloadUserInfo()
  }

  const addToDictionary = (dictionary: object) => {
    const d = getDictonaryFromObject(dictionary, APP.userLenguage, APP.appVersion)
    APP.addToDictionary(d)
  }

  const getUserData = () => {
    return SESSION.user
  }

  const getFullName = () => {
    return SESSION.userFullName
  }

  const getCompanyData = () => {
    return SESSION.company
  }

  const getCompanyUUID = () => {
    return SESSION.company.uuid
  }

  const getUserGlobalId = () => SESSION.user.idGlobal

  const setDefaultLanguage = (language: string) => {
    SESSION.globalUser.language = language
    SESSION.user = {}
    SESSION.user.language = language
  }

  const getVersionApp = () => {
    return APP.appVersion
  }

  const getUserPosition = () => SESSION.user.position?.toLowerCase() || ''

  const getMembershipAC = () => SESSION.user.membership

  const isUserAccountant = computed(
    () => SESSION.user.isAccountant || getUserPosition() == 'accountant'
  )

  const getCompanyIdentification = () => SESSION.company.identification

  const getHubspotId = () => SESSION.user.hubspot?.id ?? null

  return {
    addToDictionary,
    loadUserInfo,
    reloadUserInfo,
    getFullName,
    getUserData,
    getCompanyData,
    setDefaultLanguage,
    getVersionApp,
    isUserAccountant,
    getMembershipAC,
    getCompanyUUID,
    getUserGlobalId,
    getCompanyIdentification,
    getHubspotId,
  }
}
